import MaleAvatar1 from './MaleAvatar1.png';
import MaleAvatar2 from './MaleAvatar2.png';
import MaleAvatar3 from './MaleAvatar3.png';
import MaleAvatar4 from './MaleAvatar4.png';
import FemaleAvatar1 from './FemaleAvatar1.png';
import FemaleAvatar2 from './FemaleAvatar2.png';
import FemaleAvatar3 from './FemaleAvatar3.png';
import FemaleAvatar4 from './FemaleAvatar4.png';
import DefaultAvatar from './DefaultAvatar.png';

const AvtarArray = [
    DefaultAvatar,
    MaleAvatar1,
    MaleAvatar2,
    MaleAvatar3,
    MaleAvatar4,
    FemaleAvatar1,
    FemaleAvatar2,
    FemaleAvatar3,
    FemaleAvatar4,
];

export default AvtarArray;